import styled from 'styled-components';
import { Input, token } from '@bynder/design-system';

// mimic placeholder style for masked input
export const LinkableInput = styled(Input)<{ linked?: boolean; tabIndex?: number }>`
    padding-right: ${(props) => !props.iconRight && '0'};

    & input:not(:focus) {
        color: ${(props) => props.linked && `${token.colorTextDisabled} !important`};
    }
`;
